import { render, staticRenderFns } from "./PYBUserUpload.vue?vue&type=template&id=5cde8ea8&scoped=true&"
import script from "./PYBUserUpload.vue?vue&type=script&lang=ts&"
export * from "./PYBUserUpload.vue?vue&type=script&lang=ts&"
import style0 from "./PYBUserUpload.vue?vue&type=style&index=0&id=5cde8ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cde8ea8",
  null
  
)

export default component.exports